import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useReservationTime = (idSubSpace) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const goToDatePicker = () => {
    navigate(idSubSpace ? '/reservation-date' : '/reservation-date/' + idSubSpace);
  };

  const handleSubmit = async (values, onReservationTime) => {
    setLoading(true);
    setError(null);
    try {
      await onReservationTime(values);
    } catch (err) {
      setError('Error reservation time. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handleSubmit,
    goToDatePicker,
  };
};
